import { FORTA_ERROR } from '../../../../utils/colors';

// FHButton's disabled styles inherit a washed-out icon color; keep the error icon readable.
export const SELECTION_LIST_ERROR_BUTTON_SX = {
  '& .MuiButton-startIcon, &.Mui-disabled .MuiButton-startIcon': {
    color: FORTA_ERROR,
    opacity: 1,
  },
};
